import React from 'react';
import PropTypes from 'prop-types';
import sample from 'lodash/sample';

import {
  ANALYTICS_NAME,
  BASE_URL,
} from './Constants';

import {
  Container,
  Loader,
  MetaDesktop,
  MetaMobile,
  Close,
  ImageWrapper,
  Caption,
  Navigation,
  ImageActionsContainer,
  ImageContainer,
  RightRail,
  Previous,
  Next,
  Image,
  Title,
} from '../universal_modal/SharedComponents';
import ImageActions from '../universal_modal/ImageActions';
import FailedPlaceholder from '../universal_modal/FailedPlaceholder';
import DetailsMediaCredit from '../universal_modal/DetailsMediaCredit';
import UniversalModalDetails from '../universal_modal/UniversalModalDetails';
import BrandsLeaderboard from '../universal_modal/BrandsLeaderboard';
import RequireRegisterPopup, { PERMISSION_TYPES } from '../RequireRegisterPopup';
import AdHolder from '../AdHolder';
import {
  NO_PROJECT_TYPE,
} from '../universal_modal/Constants';
import {
  IMAGE_SEARCH_URL,
} from '../image_search/Constants';
import {
  AD_CLIENTS, AD_UNITS as GAM_AD_UNITS,
} from '../../services/constants';
import {
  arrayToReadableString,
} from '../../services/utils';
import APIClient from '../../services/APIClient';

export default class IdeaDetails extends UniversalModalDetails {
  constructor(props) {
    super(props);

    this.ANALYTICS_NAME = ANALYTICS_NAME;
    this.state = {
      ...this.state,
      ...this.defaultState(),
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  updateMediaCredit = ({ firm: { slug: newFirmSlug, name: newFirmName } }) => {
    if (newFirmSlug && newFirmName) {
      const { items, activeItemIndex } = this.state;
      const itemsClone = [...items];
      itemsClone[activeItemIndex] = {
        ...(itemsClone[activeItemIndex] || {}),
        creditName: newFirmName,
        creditSlug: newFirmSlug,
      };
      this.setState({ items: itemsClone });
    }
  };

  getActiveItemDetails = () => {
    const { items, activeItemIndex } = this.state;

    if (!items || !items.length || !items[activeItemIndex] || items[activeItemIndex].isLoaded) {
      return;
    }
    this.setState({ isLoading: true });

    const query = `{
      allImages(first: 1, mediaItemAttributionId: ${items[activeItemIndex].id}) {
        images: edges {
          node {
            globalId
            url
            mediaAttributionId
            projectUrl
            levelTwoProjectTypes
            firmSlugs
            firmNames
            firmIds
            projectName
            locations
            creditName
            creditSlug
            mediaId
          }
        }
      }
    }`;
    APIClient(query, true).then((data) => {
      if (!this.isUnmounted) {
        const updatedItems = [...items];
        const { images } = data.allImages;
        updatedItems[activeItemIndex] = {
          ...items[activeItemIndex],
          ...images.length ? images[0].node : {},
          isLoaded: Boolean(images.length),
          // To be replaced with more reliable logic instead of random
          brandsProjectType: sample(
            images.length ? images[0].node.levelTwoProjectTypes : null,
          ) || NO_PROJECT_TYPE,
        };

        this.setState({ items: updatedItems, isLoading: false });
      }
    }).catch(() => {});
  }

  getDocumentTitle = () => {
    const { items, activeItemIndex } = this.state;
    const idea = items.length && items[activeItemIndex] ? items[activeItemIndex] : null;
    if (idea && idea.globalId) {
      let title = `Idea ${idea.id}`;
      if (idea.projectName) {
        title = `${title}: ${idea.projectName}`;
        if (idea.firmNames && idea.firmNames.length) {
          title = `${title} by ${idea.firmNames[0]}`;
        }
        if (idea.locations && idea.locations.length) {
          title = `${title} in ${idea.locations[0]}`;
        }
      }
      return title;
    }
    return null;
  };

  updateDocumentTitle = () => {
    const title = this.getDocumentTitle();
    if (title) {
      document.title = title;
    }
  };

  pushHistory = () => {
    const { items, activeItemIndex } = this.state;
    this.props.pushHistory(`/${BASE_URL}/${items[activeItemIndex].id}/`);
  };

  handleCloseClick = () => {
    if (this.props.isUniversalModal) {
      this.props.close(true);
    }
  }

  // Override generic open event
  triggerGenericOpenEvent = () => {}

  // BrandsLeaderboard component is responsible for triggering open event to send data along
  triggerOpenEvent = (props = {}) => {
    this.segment.track(this.ANALYTICS_NAME.MODAL_OPENED, props);
  }

  defaultState = () => ({
  });

  render() {
    const { isLoading, items, activeItemIndex } = this.state;
    const { isUniversalModal } = this.props;

    const isValidItem = items && items.length && typeof activeItemIndex === 'number' && items[activeItemIndex];
    const item = isValidItem ? items[activeItemIndex] : {};
    const meta = isValidItem ? `${activeItemIndex + 1} / ${items.length}` : null;

    const {
      id = null,
      url = null,
      projectName = null,
      projectUrl = null,
      creditName = null,
      firmNames = [],
      firmSlugs = [],
      firmIds = [],
      isLoaded = false,
    } = item;
    const firmsReadableString = arrayToReadableString(firmNames, { serialComma: true });

    return (
      <Container>
        {/* Meta */}
        <MetaDesktop>{meta}</MetaDesktop>
        {/* Close Button */}
        <Close
          href={isUniversalModal ? null : IMAGE_SEARCH_URL}
          onClick={this.handleCloseClick}
        />

        {/* Left Area - Image */}
        <ImageContainer>
          {/* Image */}
          <ImageWrapper>
            {isLoading && <Loader />}
            {!isLoading && !isLoaded && (
            <FailedPlaceholder
              back={{
                text: isUniversalModal ? 'back' : 'to all images',
                href: isUniversalModal ? null : IMAGE_SEARCH_URL,
                onClick: () => {
                  if (isUniversalModal) {
                    this.props.close(true);
                  }
                },
              }}
            />
            )}
            {isLoaded && (
            <Image
              url={url}
              title={projectName}
              company={firmsReadableString}
              credit={creditName}
            />
            )}
          </ImageWrapper>
          {/* Caption */}
          <Caption top>
            <MetaMobile>{meta}</MetaMobile>
            <Title
              name={projectName}
              url={projectUrl}
              companyNames={firmNames}
              companySlugs={firmSlugs}
              companyUrlRoot="firms"
              linkAllImages
              ANALYTICS_NAME={ANALYTICS_NAME}
            />
            <DetailsMediaCredit
              media={item}
              isEditable={Boolean(this.userResource.canEditProject(firmIds))}
              callback={this.updateMediaCredit}
            />
          </Caption>
          {/* Navigation */}
          <Navigation>
            <Previous onClick={() => this.previous({ event: ANALYTICS_NAME.ON_IMAGE_PREVIOUS })} />
            <Next onClick={() => this.next({ event: ANALYTICS_NAME.ON_IMAGE_NEXT })} />
          </Navigation>
          {/* Image Actions */}
          <ImageActionsContainer>
            <ImageActions
              item={item}
              ANALYTICS_NAME={ANALYTICS_NAME}
              segment={this.segment}
              openRequireRegister={this.openRequireRegister}
            />
          </ImageActionsContainer>
        </ImageContainer>

        {/* Right Area - Rail */}
        <RightRail>
          {/* Project Type Brands */}
          <BrandsLeaderboard
            id={id}
            projectTypeText={item.brandsProjectType}
            parentIsLoading={isLoading}
            mediaItemUrl={url}
            segment={this.segment}
            triggerOpenEvent={this.triggerOpenEvent}
            refreshAd={this.refreshAd}
          />
          {/* Ad-Unit */}
          <AdHolder
            client={AD_CLIENTS.GAM}
            adUnit={GAM_AD_UNITS.IMAGE_MODAL_PROJECT}
            ref={this.adHolderRef}
            center
          />
        </RightRail>
        {/* Content Gates */}
        {this.state.openRequireRegister && (
        <RequireRegisterPopup
          submitProfessional
          joinCompany={this.state.permissionType === PERMISSION_TYPES.FIND_SIMILAR}
          permissionDestinationTitle={this.state.destinationTitle}
          permissionType={this.state.permissionType}
          nextParam={this.state.requireRegisterNext}
          onClose={this.closeRequireRegister}
        />
        )}
      </Container>
    );
  }
}

IdeaDetails.propTypes = {
  isUniversalModal: PropTypes.bool,
};

IdeaDetails.defaultProps = {
  isUniversalModal: false,
};
